<template>
  <div v-if="auction.bids">
    <div class="subtitle-form label-heading flex-row" :class="getStatusClass(auction.status)">
      <div class="inline">
        <h3 style="margin: 0">Registered Bidders</h3>
      </div>
    </div>
    <template v-if="isMultilotType(auction.procurementMethodType)">
      <div v-for="lot in auction.lots" :key="lot.id" class="multilot-lot">
        <div class="subtitle-form multilot-lot__title">
          <strong>{{ lot.title }}</strong>
          <span class="multilot-lot__starting">
            Starting price:
            {{ formatCurrencyAmount(lot.value.amount, lot.value.currency, { prefixSymbol: true }) }}
          </span>
        </div>
        <v-data-table
          v-if="bidsForLot(lot.id).length !== 0"
          :headers="multilotBidderHeader"
          :items="bidsForLot(lot.id)"
          hide-default-footer
          class="data-table subscribers-form bidders elevation-1"
        >
          <template v-slot:item="{ item }">
            <tr
              :style="{
                background:
                  auction.status === COMPLETE_STATUS && isLotWinner(lot.id, item)
                    ? 'rgb(209, 227, 230)'
                    : null,
              }"
            >
              <td>
                <strong>{{ item.tenderers[0].name }}</strong>
                <br />
                {{ item.tenderers[0].contactPoint.email }}
              </td>
              <td v-if="item.date">{{ formatDate(item.date) }}</td>
              <td v-else></td>
              <td class="text-xs-left">
                <span v-if="lotValueForBid(item, lot.id) && lotValueForBid(item, lot.id).value">
                  <strong>
                    {{
                      formatCurrencyAmount(
                        lotValueForBid(item, lot.id).value.amount,
                        lotValueForBid(item, lot.id).value.currency,
                        { prefixSymbol: true }
                      )
                    }}
                  </strong>
                </span>
                <span v-else> - </span>
              </td>
              <td
                v-if="
                  lotParticipationUrlForBid(item, lot.id) &&
                  isTenderingOrAuctionStatus(auction.status)
                "
                style="position: relative"
              >
                <v-layout row align-center>
                  <a
                    :href="lotParticipationUrlForBid(item, lot.id)"
                    :title="lotParticipationUrlForBid(item, lot.id)"
                    target="_blank"
                    >Participation Url</a
                  >
                  &nbsp;
                  <v-tooltip bottom>
                    <template #activator="{ on }">
                      <img
                        src="../../assets/copy.png"
                        class="copy"
                        alt="Copy"
                        @click="copyToClipboard(lotParticipationUrlForBid(item, lot.id))"
                        v-on="on"
                      />
                    </template>
                    <div>COPY</div>
                  </v-tooltip>
                </v-layout>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </template>
    <div v-else>
      <v-data-table
        v-if="auction.bids.length !== 0"
        :headers="bidderHeader"
        :items="auction.bids"
        :sort-by.sync="sortBidders.sortBy"
        :sort-desc.sync="sortBidders.descending"
        hide-default-footer
        class="data-table subscribers-form bidders elevation-1"
      >
        <template v-slot:item="{ item }">
          <tr
            v-if="
              !isAnonymousBidder ||
              (isAnonymousBidder &&
                item.id === auction.bids[auction.bids.length - 1].id &&
                isAnonymousBidderCreatedBid)
            "
            :style="{
              background:
                auction.status === COMPLETE_STATUS && winner.id === item.id
                  ? 'rgb(209, 227, 230)'
                  : null,
            }"
          >
            <td
              v-if="!(editBid && showEditBid.element === item.id)"
              @mouseover="checkIsEditBid(item.id)"
              @mouseleave="checkIsEdited"
              style="position: relative"
            >
              <strong>{{ item.tenderers[0].name }}</strong>
              <br />
              {{ item.tenderers[0].contactPoint.email }}
              <div
                v-if="
                  showEditBid.element === item.id &&
                  auction.status === ACTIVE_TENDERING_STATUS &&
                  loginInfo.isLogged
                "
                class="edit-bid-section"
              >
                <div
                  v-if="
                    !editBid &&
                    auction.status !== COMPLETE_STATUS &&
                    auction.status !== UNSUCCESSFUL_STATUS
                  "
                >
                  <v-icon
                    id="edit-bid"
                    color="teal"
                    @click.prevent="copyBid(item)"
                    title="edit"
                    left
                  >
                    edit
                  </v-icon>
                </div>
              </div>
            </td>
            <td v-if="editBid && showEditBid.element === item.id" style="position: relative">
              <br />
              <input
                v-model="copyBidInfo.name"
                class="custom-input-edit"
                style="padding: 0 0 0 4px"
              />
              <br /><br />
              <input
                v-model="copyBidInfo.email"
                class="custom-input-edit"
                style="padding: 0 0 0 4px"
              />
              <br /><br />
              <div v-if="editBid" class="edit-bid-section-event">
                <v-icon
                  id="discard-edit-bid"
                  @click.prevent="editBid = false"
                  color="red lighten-3"
                  title="Discard"
                  dark
                  >close</v-icon
                >
                <v-icon
                  id="confirm-edit-bid"
                  color="teal"
                  @click.prevent="saveNewBidInfo(item)"
                  title="Save"
                  right
                  >done</v-icon
                >
              </div>
            </td>
            <td v-if="item.date">{{ formatDate(item.date) }}</td>
            <td v-else></td>
            <td
              v-if="
                !(editBidValue && showEditBid.elementValue === item.id) &&
                (auction.procurementMethodType !== INSIDER_TYPE ||
                  auction.status === COMPLETE_STATUS)
              "
              class="text-xs-left"
              @mouseover="checkIsEditBidValue(item.id)"
              @mouseleave="checkIsEditedValue"
              style="position: relative"
            >
              <span v-if="item.value.amount">
                <strong>
                  {{ formatCurrencyAmount(item.value.amount, item.value.currency, { prefixSymbol: true }) }}
                </strong>
              </span>
              <span v-else> - </span>
              <div
                v-if="
                  showEditBid.elementValue === item.id &&
                  auction.status === ACTIVE_TENDERING_STATUS &&
                  loginInfo.isLogged
                "
                class="edit-bid-section edit-bid-section__bid"
              >
                <div
                  v-if="
                    !editBidValue &&
                    auction.status !== COMPLETE_STATUS &&
                    auction.status !== UNSUCCESSFUL_STATUS
                  "
                >
                  <v-icon
                    id="edit-bid-value"
                    color="teal"
                    @click.prevent="copyBidValue(item.value.amount)"
                    title="edit"
                    right
                  >
                    edit
                  </v-icon>
                </div>
              </div>
            </td>
            <td
              v-if="editBidValue && showEditBid.elementValue === item.id"
              style="position: relative"
            >
              <br />
              <input
                v-model="copyBidInfo.value"
                class="custom-input-edit"
                style="padding: 0 0 0 4px"
              />
              <br /><br />
              <div v-if="editBidValue" class="edit-bid-section-event">
                <v-icon
                  id="discard-edit-bid-value"
                  @click.prevent="editBidValue = false"
                  color="red lighten-3"
                  title="Discard"
                  dark
                  >close</v-icon
                >
                <v-icon
                  id="confirm-edit-bid-value"
                  color="teal"
                  @click.prevent="saveNewBidInfoValue(item)"
                  title="Save"
                  right
                  >done</v-icon
                >
              </div>
            </td>
            <td
              v-if="item.participationUrl && isTenderingOrAuctionStatus(auction.status)"
              style="position: relative"
            >
              <v-layout row align-center>
                <a :href="item.participationUrl" :title="item.participationUrl" target="_blank"
                  >Participation Url</a
                >
                &nbsp;
                <v-tooltip bottom>
                  <template #activator="{ on }">
                    <img
                      src="../../assets/copy.png"
                      class="copy"
                      alt="Copy"
                      @click="copyToClipboard(item.participationUrl)"
                      v-on="on"
                    />
                  </template>
                  <div>COPY</div>
                </v-tooltip>
              </v-layout>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
    <br /><br />
  </div>
</template>

<script>
import dayjs from 'dayjs';
import AuctionsService from '@/services/AuctionsService';
import { formatCurrencyAmount } from '@/utils/numberFormat';
import { mapActions, mapState } from 'vuex';
import { required, email, minLength, minValue, maxValue } from 'vuelidate/lib/validators';
import {
  ENGLISH_TYPE,
  TEXAS_TYPE,
  INSIDER_TYPE,
  ACTIVE_TENDERING_STATUS,
  COMPLETE_STATUS,
  UNSUCCESSFUL_STATUS,
  isTenderingOrAuctionStatus,
  isReverseLikeType,
  isMultilotType,
} from '@/constants/auction';
import {
  copyBidInfoFromBidder,
  saveUpdatedBidInList,
  getBidderStatusClass,
  copyBidderText,
} from '@/components/auctionDetailComponents/bidderShared';

export default {
  data() {
    return {
      INSIDER_TYPE,
      ACTIVE_TENDERING_STATUS,
      COMPLETE_STATUS,
      UNSUCCESSFUL_STATUS,
      editAuction: false,
      editBid: false,
      editBidValue: false,
      showEditBid: {
        isOpen: false,
        element: '',
        elementValue: '',
        name: false,
      },
      copyBidInfo: {
        name: '',
        email: '',
        bid: '',
        value: '',
      },
      snackbar: false,
      subscribers: [],
      subscribersBid: '',

      sortBidders: {
        descending: true,
        sortBy: 'date',
      },
      form: {
        name: '',
        email: '',
        bid: null,
      },
      showErrors: false,
      participationURL: '',
      bid: null,
      dialog: false,
      isParticipationUrl: false,
      isBid: false,
    };
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    auction: {
      type: Object,
    },
    isAnonymousBidder: {
      type: Boolean,
    },
    winner: {
      type: Object,
    },
    lotWinners: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState(['loginInfo', 'isAnonymousBidderCreatedBid']),
    multilotBidderHeader() {
      const header = [
        {
          text: 'Bidder (e-mail)',
          align: 'left',
          sortable: false,
          value: 'tenderers[0].name',
        },
        {
          text: 'Submission Date',
          align: 'left',
          sortable: false,
          value: 'date',
        },
        {
          text: 'Bid',
          align: 'left',
          sortable: false,
          value: 'lotValue',
        },
      ];
      if (isTenderingOrAuctionStatus(this.auction.status)) {
        header.push({
          text: 'ParticipationURL',
          align: 'left',
          sortable: false,
          value: 'url',
        });
      }
      return header;
    },
    bidderHeader() {
      let header = [
        {
          text: 'Bidder (e-mail)',
          align: 'left',
          sortable: true,
          value: 'tenderers[0].name',
        },
        {
          text: 'Submission Date',
          align: 'left',
          sortable: true,
          value: 'date',
        },
      ];
      if (this.auction.bids) {
        this.auction.bids.forEach((bidder) => {
          if (bidder.participationUrl) {
            // eslint-disable-next-line
            this.isParticipationUrl = true;
          }
          if (bidder.value && bidder.value.amount !== null) {
            // eslint-disable-next-line
            this.isBid = true;
          }
        });
        if (this.isBid) {
          header.push({
            text: 'Bid',
            align: 'left',
            sortable: true,
            value: 'value.amount',
          });
        }
        if (this.isParticipationUrl && isTenderingOrAuctionStatus(this.auction.status)) {
          header.push({
            text: 'ParticipationURL',
            align: 'left',
            sortable: false,
            value: 'url',
          });
        }
      }
      return header;
    },
  },
  watch: {
    'auction.status': {
      immediate: true,
      handler(status) {
        if (status === COMPLETE_STATUS) {
          this.sortBidders.sortBy = 'value.amount';
          this.sortBidders.descending = !isReverseLikeType(this.auction.procurementMethodType);
        }
      },
    },
  },
  methods: {
    ...mapActions(['setLoading', 'showSnackbar']),
    isTenderingOrAuctionStatus(status) {
      return isTenderingOrAuctionStatus(status);
    },
    isMultilotType(type) {
      return isMultilotType(type);
    },
    bidsForLot(lotId) {
      if (!this.auction.bids) return [];
      return this.auction.bids.filter(
        (bid) =>
          Array.isArray(bid.lotValues) && bid.lotValues.some((lv) => lv.relatedLot === lotId)
      );
    },
    lotValueForBid(bid, lotId) {
      if (!bid || !Array.isArray(bid.lotValues)) return null;
      return bid.lotValues.find((lv) => lv.relatedLot === lotId) || null;
    },
    lotParticipationUrlForBid(bid, lotId) {
      const lotValue = this.lotValueForBid(bid, lotId);
      return lotValue ? lotValue.participationUrl : null;
    },
    isLotWinner(lotId, bid) {
      const winner = this.lotWinners && this.lotWinners[lotId];
      return Boolean(winner && bid && winner.id === bid.id);
    },
    formatCurrencyAmount,
    formatDate(date) {
      return dayjs(date).format('DD/MM/YYYY HH:mm:ss');
    },
    copyBid(elem) {
      this.editBid = true;
      copyBidInfoFromBidder(this.copyBidInfo, elem);
    },
    copyBidValue(elem) {
      this.editBidValue = true;
      this.copyBidInfo.value = elem;
    },
    checkIsEditBid(elem) {
      if (!this.showEditBid.element && !this.editBid) {
        this.showEditBid.element = elem;
      }
    },
    checkIsEdited() {
      if (!this.editBid) {
        this.showEditBid.element = false;
      }
    },
    checkIsEditBidValue(elem) {
      if (!this.showEditBid.elementValue && !this.editBidValue) {
        this.showEditBid.elementValue = elem;
      }
    },
    checkIsEditedValue() {
      if (!this.editBidValue) {
        this.showEditBid.elementValue = false;
      }
    },
    saveNewBidInfo(elem) {
      let params = {
        tenderers: [{}],
      };
      if (this.copyBidInfo.name !== elem.tenderers[0].name) {
        params.tenderers[0] = {
          name: this.copyBidInfo.name,
        };
      }
      if (this.copyBidInfo.email !== elem.tenderers[0].contactPoint.email) {
        params.tenderers[0].contactPoint = {
          email: this.copyBidInfo.email,
        };
      }
      if (params.tenderers[0].contactPoint || params.tenderers[0].name) {
        this.setLoading({ show: true, text: 'Editing...' });
        AuctionsService.editBidNameEmail(this.auction.id, elem.id, params)
          .then((response) => {
            saveUpdatedBidInList(this.auction.bids, response.data);
            this.editBid = false;
            this.setLoading({ show: false, text: '' });
          })
          .catch((err) => {
            this.$emit('getDetailAuctionRequest');
            this.setLoading({ show: false, text: '' });
            this.showSnackbar(err.response.data);
          });
      }
    },
    saveNewBidInfoValue(elem) {
      let params = {
        value: {
          currency: elem.value.currency,
        },
      };
      if (this.copyBidInfo.value !== elem.value.amount) {
        params.value.amount = this.copyBidInfo.value;
      }
      if (params.value.amount) {
        this.setLoading({ show: true, text: 'Editing...' });
        AuctionsService.editBidNameEmail(this.auction.id, elem.id, params)
          .then((response) => {
            saveUpdatedBidInList(this.auction.bids, response.data);
            this.editBidValue = false;
            this.setLoading({ show: false, text: '' });
          })
          .catch((err) => {
            this.$emit('getDetailAuctionRequest');
            this.setLoading({ show: false, text: '' });
            this.showSnackbar(err.response.data);
          });
      }
    },
    copyToClipboard(data) {
      copyBidderText({
        copyText: (text) => this.$copyText(text),
        showSnackbar: this.showSnackbar,
        text: data,
      });
    },
    onCopy() {
      this.snackbar = true;
    },
    getStatusClass(status) {
      return getBidderStatusClass(status);
    },
    succesCopyToClipboard() {
      this.showSnackbar('COPIED');
    },
  },
  validations() {
    return {
      form: {
        name: {
          required,
          minLength: minLength(2),
        },
        email: {
          required,
          email,
        },
        bid: {
          required,
          minValue:
            this.auction.value &&
            (this.auction.procurementMethodType === ENGLISH_TYPE ||
              this.auction.procurementMethodType === TEXAS_TYPE)
              ? minValue(this.auction.value.amount)
              : 1,
          maxValue:
            this.auction.value && isReverseLikeType(this.auction.procurementMethodType)
              ? maxValue(this.auction.value.amount)
              : false,
        },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.bidders tr {
  position: relative;
}
.edit-bid {
  position: absolute;
  top: 10px;
  right: 0;
}
.edit-bid-section {
  position: absolute;
  left: 0;
  bottom: 50%;
  opacity: 0.8;
  font-size: 19px;
  transform: translateY(50%);
  .v-icon {
    font-size: 20px;
  }
}

.edit-bid-section__bid {
  left: -14px;
}
.edit-bid-section-event {
  position: relative;
  right: 0;
  bottom: 50%;
  opacity: 0.8;
  font-size: 19px;
  transform: translateY(50%);
  .v-icon {
    font-size: 20px;
  }
}
h1 {
  color: #396;
  font-weight: 100;
  font-size: 40px;
  margin: 20px 0px 20px;
}
.flex-row {
  margin-top: 40px !important;
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: space-between !important;
}
.errors-input {
  outline: 2px solid #e62a2aa3;
}
.errors-text {
  font-size: 11px;
  color: #e62a2aa3;
  margin-top: 8px;
  display: block;
}
div strong {
  font-size: 12px;
}
.align-start {
  align-items: start;
}
.label-heading {
  display: block;
  border-left: 5px solid #2e7f89;
  box-sizing: border-box;
  margin-left: -18px;
  padding-left: 14px;
}
.multilot-lot__title {
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin-top: 24px;
  margin-bottom: 4px;
  color: #2e7f89;
  strong {
    font-size: 14px;
  }
  .multilot-lot__starting {
    font-size: 12px;
    opacity: 0.75;
  }
}
h3 {
  text-align: left;
  color: #2e7f89;
  margin-top: 36px;
}
.subscribers-form {
  padding: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 55%;
  min-width: 900px;
  margin: 0 auto 9px auto;
  justify-content: space-between;
  flex-direction: column;
  background: #ffffff;
}
.inline {
  display: inline-block;
}
.subtitle-form {
  padding: 0 7px 0 17px;
  width: 55%;
  min-width: 900px;
  margin: 0 auto 14px auto;
  justify-content: space-between;
  flex-direction: row;
  .tbl-row,
  .tbl-row-rewerse {
    
    background: transparent;
    font-size: 9px;
    font-weight: 400;
  }
}
.strong {
  
}
.data-table td {
  text-align: left !important;
}
.tbl-row {
  width: 100%;
  text-align: left;
}
.tbl-row-rewerse {
  text-align: right;
}
.flex-center {
  display: flex;
  overflow: hidden;
}
.material-icons:hover {
  color: #2e7f89;
}
.form .card-text {
  padding: 6px 16px;
}
.card-text {
  padding: 12px 16px;
}
.custom-input-edit {
  line-height: 1.6rem;
  background: rgba(169, 169, 169, 0.2);
  padding: 0 0 0 6px;
  border: 2px solid rgb(46, 127, 137);
}
.custom-input {
  height: 42px;
  margin-bottom: 0;
  width: 100%;
}
.copy {
  cursor: pointer;
}
@media (max-width: 1000px) {
  img {
    margin-left: 34px;
  }
  .subtitle-form {
    min-width: 90% !important;
  }
  .subscribers-form,
  .invite {
    min-width: 90% !important;
  }
}
</style>
